module.exports = __webpack_public_path__ + "img/multiplayer_gamers.764d7fd2.jpg";